import React, { useEffect, useState } from "react";
import CKEditor from "ckeditor4-react";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";

import { useFormik } from "formik";
import * as Yup from "yup";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Form,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { Minus } from "react-feather";
import PostApiCall from "../../Api/Api";
import GetApiCall from "../../Api/GetApi";
import BreadCrumb from "../../Components/BreadCrumbComp";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { delay } from "../../Helper/ToastDelay";
import Notiflix, { Report } from "notiflix";
import { SomethingWrong } from "../../Helper/ErrorMessages";
import { toast } from "react-toastify";
import { getCurrentDate } from "../../Utils";
import { NotificationAction } from "../../Store/Actions/NotificationAction";
import { useDispatch, useSelector } from "react-redux";

import { PublishJob } from "../../Helper/NotificationMsg";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/material_orange.css";
import { useSocket } from "../../Helper/Socket";
import { generateCustomStyles } from "../../Helper/CustomStyleError";
import { EditorState } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

const AddNewJob = () => {
  const [allCountry, setAllCountry] = useState([]);
  const [allState, setAllState] = useState([]);
  const [allCity, setAllCity] = useState([]);
  const history = useHistory();
  const socket = useSocket();
  const jobType = [
    { value: "Full time", label: "Full time" },
    { value: "Part time", label: "Part time" },
    { value: "Contract", label: "Contract" },
  ];
  const SalaryType = [
    { value: "Per Hour", label: "Per Hour" },
    { value: "Per Day", label: "Per Day" },
    { value: "Per Week", label: "Per Week" },
    { value: "Per Month", label: "Per Month" },
  ];
  const Allqualification = [
    { value: "10th", label: "10th" },
    { value: "12th", label: "12th" },
    { value: "Diploma", label: "Diploma" },
    { value: "Graduation", label: "Graduation" },
    { value: "Post Graduation", label: "Post Graduation" },
    { value: "CA/CS/CMA Foundation", label: "CA/CS/CMA Foundation" },
    { value: "CA/CS/CMA Inter", label: "CA/CS/CMA Inter" },
    { value: "CA/CS/CMA Finalist", label: "CA/CS/CMA Finalist" },
    { value: "CA/CS/CMA", label: "CA/CS/CMA" },
  ];
  const expType = [
    { value: "Months", label: "Months" },
    { value: "Years", label: "Years" },
  ];
  const user = useSelector((state) => state.login);
  const dispatch = useDispatch();
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Job Title is required"),
    experiencetype: Yup.object().required("Experience type is required"),
    // salarytype: Yup.object().required("Salary type is required"),
    // category: Yup.string().required("Category is required"),
    // salarytype: Yup.object().shape({
    //   value: Yup.string().required("Salary type is required"),
    // }),
    // experiencetype: Yup.object().shape({
    //   value: Yup.string().required("Experience Type is required"),
    // }),
    type: Yup.object().shape({
      value: Yup.string().required("Job type is required"),
    }),

    // employeremail: Yup.string()
    //   .email("Invalid email")
    //   .required("Email is required"),

    jobdescription: Yup.string().required("Job description is required"),
    // duties: Yup.string().required("Duties is required"),
    // skillset: Yup.string().required("Role is required"),

    country: Yup.object().shape({
      value: Yup.string().required("Country is required"),
    }),

    city: Yup.object().shape({
      value: Yup.string().required("City is required"),
    }),
    state: Yup.object().shape({
      value: Yup.string().required("State is required"),
    }),
    pincode: Yup.string()
      .notRequired("Pincode is required")
      .matches(/^[0-9]{6}$/, "Invalid Pincode"), // Ensure 6 digits

    // experience: Yup.string().required("Education is required"),
    // company: Yup.string().required("Company is required"),
    // employername: Yup.string().required("Name is required"),
    // employerdesignation: Yup.string().required("Degisnation is required"),
    // employeremail: Yup.string().required("Employee Email is required"),
    closingdate: Yup.string().required("Closing date is required"),
    // maxsalary: Yup.number().required("Max Salary is required"),
    // maxexperience: Yup.number().required("Experience is required"),

    openingdate: Yup.string().required("Opening date is required"),
    auditdate: Yup.string().required("Audit date is required"),
    auditenddate: Yup.string().required("Audit End date is required"),
    // auditenddate: Yup.string().when('auditenddatetype', (auditenddatetype, schema) => 
    //   auditenddatetype == 'No' 
    //     ? schema.required('Audit End date is required') 
    //     : schema.notRequired()
    // ),
 

    positions: Yup.number().required("No of Position is required"),

    // employermobile: Yup.string()
    //   .required("Contact Number is required")
    //   .matches(/^[0-9]{10}$/, "Invalid Contact Number"),
    status: Yup.string().required("Active status is required"),
  });
  const formik = useFormik({
    initialValues: {
      title: "",
      type: "",
      category: "",
      area: [],
      country: { value: 101, label: "India" },
      state: allState[0],
      city: allCity[0],
      pincode: "",
      jobdescription:
        "<ul>\n\t<li>Brief description -</li>\n\t<li>Whether Checklist based (Y/N) -</li>\n\t<li>Whether App based (Y/N) -&nbsp;</li>\n\t<li>Whether HHD based (Y/N) -&nbsp;</li>\n\t<li>Gender preference -&nbsp;</li>\n\t<li>Mandatory reporting time at audit location -&nbsp;</li>\n\t<li>Report submission timelines -&nbsp;</li>\n\t<li>Phone Requirement (Android / IOS) -&nbsp;</li>\n\t<li>Photographs requirements -&nbsp;</li>\n\t<li>Training requirement</li>\n</ul>\n",

      duties: "",
      skillset:
        '<p>A.&nbsp;&nbsp; &nbsp;Payment Terms:</p>\n\n<ol>\n\t<li>&nbsp;For Payment related queries reach only to <a href="mailto:support@beteljobs.com">support@beteljobs.com</a> or through WhatsApp Number 9319179297</li>\n\t<li>Do not discuss and disclose fee with the client/any other team member.</li>\n\t<li>Payment will be made within 7 working days from the completion of assignment and confirmation by client.</li>\n\t<li>Fee will not be paid in case auditor leave or backout from the assignment before completion of the assignment.&nbsp;</li>\n\t<li>If candidate is late by more than 30 minute than his fee can be reduced by 50%.&nbsp;</li>\n\t<li>Inform us regarding any changes in planned mandays, travelling reimbursement etc. instructed by clients.We will not be responsible for non-payment of additional&nbsp;mandays or travelling reimbursement if not informed to us in advance and done only based on instruction of client.</li>\n</ol>\n\n<p>B.&nbsp;&nbsp; &nbsp;Other Terms:&nbsp;</p>\n\n<ol>\n\t<li>Normal working duration will be 9 hours until otherwise informed specifically.</li>\n\t<li>&nbsp;Full details of the assignment shall be provided by us.&nbsp;</li>\n\t<li>Actual assignment date and duration may vary.&nbsp;</li>\n\t<li>You cannot dropout of assignment once training given or 1 day before assignment whichever is earlier.&nbsp;</li>\n\t<li>Dress code is Formal. Sleeper, hoodies etc. are not allowed.</li>\n</ol>\n',

      experience: "",
      company: "",
      employername: "",
      employerdesignation: "",
      employeremail: "",
      employermobile: "",
      minsalary: 0,
      maxsalary: null,
      salarytype: null,
      minexperience: 0,
      maxexperience: 0,
      experiencetype: null,
      positions: null,
      remotework: "",
      closingdate: "",
      openingdate: "",
      status: "Active",
      approved: "",
      qualification: null,
      address: "",
      AssignmentDuration: "",
      Laptop: "",
      Vehicle: "",
      auditdate: "",
      auditenddate: "",
      auditenddatetype: "No",
      projectcoordinatoremail:[],
      projectcoordinatorname:""
    },
    validationSchema: validationSchema,
    validateOnBlur: true, // Ensure validation runs on blur
    onSubmit: async (values, { resetForm }) => {
      try {
        Notiflix.Loading.standard();
        const payload = {
          title: values.title,
          type: values.type?.value,
          category: values.category,

          qualification: values?.qualification?.label ?? "",
          address: values.address || "",
          assignduration: values.AssignmentDuration || "",
          laptop: values.Laptop || "",
          vehicle: values.Vehicle || "",

          country: values.country.label,
          state: values.state.label,
          city: values.city.label,
          pincode: values.pincode || "",
          jobdescription: values.jobdescription,
          // "<p>To work as a web developer, you must be familiar with HTML and CSS. The standard markup language for constructing web pages is HyperText Markup Language (HTML).&nbsp; This language is widely used by web developers to create web pages.CSS, on the other hand, is used to create the page&rsquo;s layout, color, fonts, and style. Both of these languages are required to work as a front-end developers</p>\n",
          // duties: values.duties,
          // "<p>HTML lays the foundation for creating web pages. You can use the technology to create personalized websites with unique (and advanced) features and functions. For the uninitiated, HTML5 is the most recent version, and you should start learning it right away.</p>\n",
          skillset: values.skillset,
          // '<p>CSS (Cascading Style Sheet), on the other hand, is a must-have in&nbsp;<a href="https://www.scaler.com/courses/web-development" target="_blank">Web development</a>, as we previously stated. We utilize it to give our website a unique look, including the layout and design. We also utilize it to ensure that our website looks good on a variety of devices and screen sizes.</p>\n',
          experience: "",
          // "<p>With frameworks, it is basically the same. The JavaScript framework is a JavaScript application framework that allows programmers to edit functions and use them as needed. Why build something from scratch if, by all means, you can use something and adapt it to your project? Frameworks simplify your work but give you a more standardized approach to coding. These frameworks also make it feasible for the programmer to create a device-responsive application. Some frameworks are Vue.js, React, and Angular.js.</p>\n",
          company: values.company || "",
          employername: values.employername,
          employerdesignation: values.employerdesignation,
          employeremail: values.employeremail,
          employermobile: values.employermobile,
          minsalary: values.minsalary,
          maxsalary: values.maxsalary,
          salarytype: values?.salarytype?.value || "",
          minexperience: values.minexperience || 0,
          maxexperience: values.maxexperience || 0,
          experiencetype: values?.experiencetype?.value,
          positions: values.positions,
          remotework: values.remotework,
          closingdate: values.closingdate,
          openingdate: values.openingdate,
          status: values.status,
          approved: values.approved,
          auditdate: values.auditdate,
          auditenddate: values.auditenddate,
          auditenddatetype: values.auditenddatetype || "No",
        
          projectcoordinatorname: values.projectcoordinatorname,
        };
        let cityArr = await values?.area
          .map((ele) => ele.value.trim())
          .join(",");
        payload.area = cityArr;
        let emailArr = await values?.projectcoordinatoremail
          .map((ele) => ele.value.trim())
          .join(",");
        payload.projectcoordinatoremail = emailArr;
     
        const res = await PostApiCall.postRequest(payload, "AddJobOpening");
        if (res.status === 200 || res.status === 201) {
          Notiflix.Loading.remove();
          // toast.success("Job Publish Successfully", {
          //   autoClose: delay,
          // });
          Report.success(
            `Job Publish Succesfully`,
            // '"Do not try to become a person of success but try to become a person of value." <br/><br/>- Albert Einstein',
            "",
            "Okay"
          );
          socket.emit("PushSeeker", "need");

          dispatch(
            NotificationAction.addNotification({
              ...PublishJob,
              senderid: user.fld_id,
              receiverid: 0,
              usertype: "user",
              updatedat: moment().format("ll"),
            })
          );

          history.push("/publish-job");
        } else {
          toast.error(SomethingWrong, {
            autoClose: delay,
            toastId: 1,
          });
          Notiflix.Loading.remove();
        }
      } catch (error) {
        toast.error(SomethingWrong, {
          autoClose: delay,
          toastId: 1,
        });
        Notiflix.Loading.remove();
      }
    },
  });


  const submitHandler = async () => {
    formik.handleSubmit();
    setTimeout(() => {
      if (Object.keys(formik.errors).length > 0) {
        // Show toast for the first error message
        const firstErrorKey = Object.keys(formik.errors)[0];
        toast.error(formik.errors[firstErrorKey], { autoClose: 3000 });

        // Scroll to the first error field
        const firstErrorField = document.querySelector(".error-input");
        if (firstErrorField) {
          firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
          firstErrorField.focus();
        }
      }
    }, 100);
    window.scrollTo(0, 0);
  };


  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const getCountry = () => {
      GetApiCall.getRequest("GetCountry").then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCountry(obj?.data);

          // Notiflix.Loading.remove()
        })
      );
    };
    getCountry();
  }, []);
  useEffect(() => {
    const getState = () => {
      PostApiCall.postRequest(
        { countryid: formik.values?.country?.value },
        "GetState"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllState(obj?.data);
          formik.setFieldValue("state", obj?.data[0]);
          // Notiflix.Loading.remove()
        })
      );
    };
    getState();
  }, [formik.values.country]);
  useEffect(() => {
    const getCity = () => {
      PostApiCall.postRequest(
        { stateid: formik.values?.state?.value },
        "GetCity"
      ).then((resultdes) =>
        resultdes.json().then((obj) => {
          setAllCity(obj?.data);
          formik.setFieldValue("city", obj?.data[0]);
          // Notiflix.Loading.remove()
        })
      );
    };
    getCity();
  }, [formik.values.state, allState]);
  return (
    <section className="section mx-3  px-md-4">
      {/* breadcrumb */}
      <div className="container">
        <div className="w-100 mt-5">
          <BreadCrumb icon={false} subitem={"Add New Job"} />
        </div>
        <FormGroup>
          <Card
            id="jobCard "
            className="border-0"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Basic Information</p>
            <CardBody>
              <div>
                <Row>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Job Title<span className="mandatory">*</span>
                      </Label>
                      <Input
                        type="text"
                        name="title"
                        id="nameVertical"
                        placeholder="Job title"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.title}
                        invalid={formik.touched.title && !!formik.errors.title}
                      />
                      {formik.touched.title && formik.errors.title && (
                        <FormFeedback>{formik.errors.title}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        Job Type<span className="mandatory">*</span>
                      </Label>

                      <Select
                        className={`React ${
                          formik.touched.type && formik.errors.type
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        name="type"
                        value={formik.values.type}
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("type", selectedOption)
                        }
                        
                        options={jobType}
                        styles={generateCustomStyles("type", formik)}
                      />

                      {formik.touched.type && formik.errors.type && (
                        <FormFeedback>{formik.errors.type.value}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Industry Type</Label>
                      <Input
                        type="text"
                        name="category"
                        id="nameVertical"
                        placeholder="Industry Type"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.category}
                        invalid={
                          formik.touched.category && !!formik.errors.category
                        }
                      />
                      {formik.touched.category && formik.errors.category && (
                        <FormFeedback>{formik.errors.category}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">Minimum Qualification</Label>

                      <Select
                        className={`React ${
                          formik.touched.qualification &&
                          formik.errors.qualification
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        name="qualification"
                        value={formik.values.qualification}
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("qualification", selectedOption)
                        }
                        options={Allqualification}
                        styles={generateCustomStyles("qualification", formik)}
                      />

                      {formik.touched.qualification &&
                        formik.errors.qualification && (
                          <FormFeedback>
                            {formik.errors.qualification.value}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                  <Col sm="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Client Name</Label>
                      <Input
                        type="text"
                        name="company"
                        id="nameVertical"
                        placeholder="Client Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.company}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Project Coordinator </Label>
                      <Input
                        type="text"
                        name="projectcoordinatorname"
                        id="nameVertical"
                        placeholder="Name"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.projectcoordinatorname}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Project Coordinator Email</Label>
                  
                       <CreatableSelect
                        isClearable
                        className={`React ${
                          formik.touched.projectcoordinatoremail && formik.errors.projectcoordinatoremail
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="Enter Email"
                        name="projectcoordinatoremail"
                        isMulti
                        placeholder="Enter Email"
                        noOptionsMessage={() => "Type to create new Enter Email"}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("projectcoordinatoremail", selectedOption)
                        }
                        value={formik.values.projectcoordinatoremail}
                        onBlur={formik.handleBlur}
                        styles={generateCustomStyles("projectcoordinatoremail", formik)}
                      />
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Job Location</p>
            <CardBody>
              <div>
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Address
                        {/* <span className="mandatory">*</span> */}
                      </Label>
                      <Input
                        type="textarea"
                        className="p-3"
                        name="address"
                        placeholder="Enter your address"
                        // id="nameVertical"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.address}
                        maxLength={400}
                        // invalid={
                        //   formik.touched.AuditorAddress &&
                        //   !!formik.errors.AuditorAddress
                        // }
                      />
                      <div
                        className="text-end text-muted mt-1"
                        style={{ fontSize: "12px" }}
                      >
                        {formik.values.address.length}/400
                      </div>
                      {/* {formik.touched.AuditorAddress &&
                        formik.errors.AuditorAddress && (
                          <FormFeedback>
                            {formik.errors.AuditorAddress}
                          </FormFeedback>
                        )} */}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        Country<span className="mandatory">*</span>
                      </Label>

                      <Select
                        className={`basic-single ${
                          formik.touched.AuditorCountry &&
                          formik.errors.AuditorCountry
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        name="country"
                        defaultValue={{ value: 101, label: "India" }}
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) => {
                          formik.setFieldValue("country", selectedOption);
                          formik.setFieldValue("state", "");
                          formik.setFieldValue("city", "");
                        }}
                        options={allCountry}
                        // value={formik.values.country}
                        styles={generateCustomStyles("country", formik)}
                      />

                      {formik.touched.country && formik.errors.country && (
                        <FormFeedback>
                          {formik.errors.country.value}
                        </FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        State<span className="mandatory">*</span>
                      </Label>
                      <Select
                        className={`basic-single ${
                          formik.touched.state && formik.errors.state
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        name="state"
                        defaultValue={allState[0]}
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) => {
                          formik.setFieldValue("state", selectedOption);
                        }}
                        value={formik.values.state}
                        options={allState}
                        styles={generateCustomStyles("state", formik)}
                      />
                      {formik.touched.state && formik.errors.state && (
                        <FormFeedback>{formik.errors.state.value}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="">
                        City<span className="mandatory">*</span>
                      </Label>
                      <Select
                        className={`basic-single ${
                          formik.touched.city && formik.errors.city
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        name="city"
                        onBlur={formik.handleBlur}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("city", selectedOption)
                        }
                        defaultValue={allCity[0]}
                        options={allCity}
                        value={formik.values.city}
                        styles={generateCustomStyles("city", formik)}
                      />
                      {formik.touched.city && formik.errors.city && (
                        <FormFeedback>{formik.errors.city.value}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Areas</Label>
                      <CreatableSelect
                        isClearable
                        className={`React ${
                          formik.touched.area && formik.errors.area
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="Select.."
                        name="area"
                        isMulti
                        placeholder="Enter.."
                        noOptionsMessage={() => "Type to create new city name"}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("area", selectedOption)
                        }
                        value={formik.values.area}
                        onBlur={formik.handleBlur}
                        styles={generateCustomStyles("area", formik)}
                      />
                      {formik.touched.area && formik.errors.area && (
                        <FormFeedback>{formik.errors.area}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="6">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Pincode</Label>
                      <Input
                        type="text"
                        name="pincode"
                        id="nameVertical"
                        placeholder="Pincode"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.pincode}
                 
                        invalid={
                          formik.touched.pincode && !!formik.errors.pincode
                        }
                      />
                      {formik.touched.pincode && formik.errors.pincode && (
                        <FormFeedback>{formik.errors.pincode}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
        
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-3 headingStyle">Job Description</p>
            <CardBody>
              <Form>
                <Row>
                  <Col sm="12">
                    <FormGroup>
                      {/* <Label htmlFor="nameVertical">
                      Job Description<span className="mandatory">*</span>
                    </Label> */}
                      <CKEditor
                        config={{
                          extraPlugins: "justify,font,colorbutton,image2",
                          height: "300px",
                        }}
                        data={formik.values.jobdescription}
                        name={"jobdescription"}
                        onBlur={formik.handleBlur}
                        onChange={(event) => {
                          formik.setFieldValue(
                            "jobdescription",
                            event.editor.getData()
                          );
                        }}
                      />
                      {/* <Editor />5 */}
                      {formik.touched.jobdescription &&
                        formik.errors.jobdescription && (
                          <div
                            style={{
                              width: "100%",
                              marginTop: ".25rem",
                              fontSize: "80%",
                              color: "#dc3545",
                            }}
                          >
                            {formik.errors.jobdescription}
                          </div>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="12">
                    <FormGroup>
                      <p className="my-3 headingStyle">General Description</p>

                      <CKEditor
                        config={{
                          extraPlugins: "justify,font,colorbutton,image2",
                          height: "300px",
                        }}
                        name="skillset"
                        data={formik.values.skillset}
                        onBlur={formik.handleBlur}
                        onChange={(event) => {
                          formik.setFieldValue(
                            "skillset",
                            event?.editor?.getData()
                          );
                        }}
                      />
                      {formik.errors.skillset && (
                        <div
                          style={{
                            width: "100%",
                            marginTop: ".25rem",
                            fontSize: "80%",
                            color: "#dc3545",
                          }}
                        >
                          {formik.errors.skillset}
                        </div>
                      )}
                    </FormGroup>
                  </Col>

                </Row>
              </Form>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Salary & Experience</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Min Salary</Label>
                      <Input
                        type="number"
                        name="minsalary"
                        id="nameVertical"
                        placeholder="Minimum Salary"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.minsalary}
                        invalid={
                          formik.touched.minsalary && !!formik.errors.minsalary
                        }
                      />
                      {formik.touched.minsalary && formik.errors.minsalary && (
                        <FormFeedback>{formik.errors.minsalary}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>
                  <Col sm="1" className="align-self-center">
                    <div className="text-center">
                      <Minus />
                    </div>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="">Max Salary</Label>

                      <Input
                        type="number"
                        name="maxsalary"
                        id="nameVertical"
                        placeholder="Maximum Salary"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.maxsalary}
                        invalid={
                          formik.touched.maxsalary && !!formik.errors.maxsalary
                        }
                      />
                      {formik.touched.maxsalary && formik.errors.maxsalary && (
                        <FormFeedback>{formik.errors.maxsalary}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="3">
                    <FormGroup>
                      <Label htmlFor="nameVertical">Salary Type</Label>
                     
                      <CreatableSelect
                        isClearable
                        className={`React ${
                          formik.touched.salarytype && formik.errors.salarytype
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="Select.."
                        name="salarytype"
                        options={SalaryType}
                        placeholder="Select.."
                        onBlur={formik.handleBlur}
                        noOptionsMessage={() => "Select"}
                        onChange={(selectedOption) =>
                          formik.setFieldValue("salarytype", selectedOption)
                        }
                        value={formik.values.salarytype}
                        styles={generateCustomStyles("salarytype", formik)}
                      />
                      {formik.touched.salarytype &&
                        formik.errors.salarytype && (
                          <FormFeedback>
                            {formik.errors.salarytype}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Min Experience<span className="mandatory">*</span>
                      </Label>
                      <Input
                        type="number"
                        min={0}
                        name="minexperience"
                        id="nameVertical"
                        placeholder="Minimum Experience"
                        onBlur={formik.handleBlur}
                        onChange={formik.handleChange}
                        value={formik.values.minexperience}
                      />
                    </FormGroup>
                  </Col>
                  <Col sm="1" className="align-self-center">
                    <div className="text-center">
                      <Minus />
                    </div>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="">Max Experience</Label>

                      <Input
                        type="number"
                        min={0}
                        name="maxexperience"
                        id="nameVertical"
                        placeholder="Maximum Experience"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.maxexperience}
                        invalid={
                          formik.touched.maxexperience &&
                          !!formik.errors.maxexperience
                        }
                      />
                      {formik.touched.maxexperience &&
                        formik.errors.maxexperience && (
                          <FormFeedback>
                            {formik.errors.maxexperience}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="3">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Experience Type<span className="mandatory">*</span>
                      </Label>
                      <Select
                        className={`React ${
                          formik.touched.experiencetype &&
                          formik.errors.experiencetype
                            ? "is-invalid"
                            : ""
                        }`}
                        classNamePrefix="select"
                        styles={generateCustomStyles("experiencetype", formik)}
                        name="experiencetype"
                        onChange={(selectedOption) =>
                          formik.setFieldValue("experiencetype", selectedOption)
                        }
                        onBlur={formik.handleBlur}
                        value={formik.values.experiencetype}
                        options={expType}
                      />
                      {formik.touched.experiencetype &&
                        formik.errors.experiencetype && (
                          <FormFeedback>
                            {formik.errors.experiencetype}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Audit Duration</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Audit Start Date<span className="mandatory">*</span>
                      </Label>

                      <Flatpickr
                        value={formik.values.auditdate}
                        className={`form-control ${
                          formik.touched.auditdate &&
                          formik.errors.auditdate
                            ? "is-invalid"
                            : ""
                        } ${
                          formik.touched.auditdate &&
                          formik.errors.auditdate
                            ? "invalid-border"
                            : ""
                        }`}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate: new Date().fp_incr(0),
                          // minDate: new Date().fp_incr(0),
                        }}
                        styles={generateCustomStyles("auditdate", formik)}
                        name="auditdate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "auditdate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format("YYYY-MM-DD");
                            formik.setFieldValue("auditdate", formattedDate);
                          } else {
                            formik.setFieldValue("auditdate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.auditdate &&
                        formik.errors.auditdate && (
                          <FormFeedback>
                            {formik.errors.auditdate}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
            
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Audit End Date<span className="mandatory">*</span>
                      </Label>

                      <Flatpickr
                        value={formik.values.auditenddate}
                        className={`form-control ${
                          formik.touched.auditenddate &&
                          formik.errors.auditenddate
                            ? "is-invalid"
                            : ""
                        } ${
                          formik.touched.auditenddate &&
                          formik.errors.auditenddate
                            ? "invalid-border"
                            : ""
                        }`}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate: new Date().fp_incr(0),
                          // minDate: new Date().fp_incr(0),
                        }}
                        styles={generateCustomStyles("auditenddate", formik)}
                        name="auditenddate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "auditenddate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format("YYYY-MM-DD");
                            formik.setFieldValue("auditenddate", formattedDate);
                          } else {
                            formik.setFieldValue("auditenddate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.auditenddate &&
                        formik.errors.auditenddate && (
                          <FormFeedback>
                            {formik.errors.auditenddate}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                  

                  <Col sm="4">
                    <div className="text-center">
                      <Label htmlFor="nameVertical">
                      Is the Audit date fixed ?
                        <span className="mandatory">*</span>
                      </Label>
                      <div
                        className={`d-flex justify-content-center ${
                          formik.touched.auditenddatetype && formik.errors.auditenddatetype
                            ? "radio-error"
                            : ""
                        }`}
                      >
                        <div className="mr-5">
                          <Input
                            type="radio"
                            name="auditenddatetype"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("auditenddatetype", "Yes")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.auditenddatetype === "Yes"}
                            value={formik.values.auditenddatetype}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="auditenddatetype"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("auditenddatetype", "No")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.auditenddatetype === "No"}
                            value={formik.values.auditenddatetype}
                          />
                          <span>No</span>
                        </div>
                      </div>
                      {formik.touched.auditenddatetype && formik.errors.auditenddatetype && (
                        <FormFeedback>{formik.errors.auditenddatetype}</FormFeedback>
                      )}
                    </div>
                  </Col>
                
                  <Col sm="12" className="mt-2">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Duration of Assignment (Days)
                      </Label>
                      <Input
                        type="textarea"
                        name="AssignmentDuration"
                        id="nameVertical"
                        className="p-3"
                        placeholder="Enter Duration"
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.AssignmentDuration}
                        invalid={
                          formik.touched.AssignmentDuration &&
                          !!formik.errors.AssignmentDuration
                        }
                      />
                      {formik.touched.AssignmentDuration &&
                        formik.errors.AssignmentDuration && (
                          <FormFeedback>
                            {formik.errors.AssignmentDuration}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
         
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Additional Information</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="2" md="6" xs="12">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        No. of Positions
                        <span className="mandatory">*</span>
                      </Label>
                      <Input
                        type="number"
                        name="positions"
                        id="nameVertical"
                        placeholder="Position"
                        // defaultValue={0}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        value={formik.values.positions}
                        invalid={
                          formik.touched.positions && !!formik.errors.positions
                        }
                      />
                      {formik.touched.positions && formik.errors.positions && (
                        <FormFeedback>{formik.errors.positions}</FormFeedback>
                      )}
                    </FormGroup>
                  </Col>

                  <Col sm="4" md="6" xs="12">
                    <div className="text-center mt-3">
                      <Label htmlFor="nameVertical">
                        Can this Job be Performed Remotely?
                      </Label>
                      <div className="d-flex justify-content-center">
                        <div className="mr-5">
                          <Input
                            type="radio"
                            name="remotework"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("remotework", "Yes")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.remotework === "Yes"}
                            value={formik.values.remotework}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="remotework"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("remotework", "No")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.remotework === "No"}
                            value={formik.values.remotework}
                          />
                          <span>No</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm="3" md="6" xs="12">
                    <div className="text-center mt-3">
                      <Label htmlFor="nameVertical">Laptop Requirement ?</Label>
                      <div className="d-flex justify-content-center">
                        <div className="mr-5">
                          <Input
                            type="radio"
                            name="Laptop"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Laptop", "Yes")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.Laptop == "Yes"}
                            value={formik.values.Laptop}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="mr-5 ">
                          {" "}
                          <Input
                            type="radio"
                            name="Laptop"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Laptop", "No")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.Laptop == "No"}
                            value={formik.values.Laptop}
                          />
                          <span>No</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="Laptop"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Laptop", "Peferable")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.Laptop == "Peferable"}
                            value={formik.values.Laptop}
                          />
                          <span>Preferably</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                  <Col sm="3" md="6" xs="12">
                    <div className="text-center mt-3">
                      <Label htmlFor="nameVertical">
                        Vehicle Requirement ?
                      </Label>
                      <div className="d-flex justify-content-center">
                        <div className="mr-5">
                          <Input
                            type="radio"
                            name="Vehicle"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Vehicle", "Yes")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.Vehicle == "Yes"}
                            value={formik.values.Vehicle}
                          />
                          <span>Yes</span>
                        </div>
                        <div className="mr-5 ">
                          {" "}
                          <Input
                            type="radio"
                            name="Vehicle"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Vehicle", "No")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.Vehicle == "No"}
                            value={formik.values.Vehicle}
                          />
                          <span>No</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="Vehicle"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("Vehicle", "Peferable")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.Vehicle == "Peferable"}
                            value={formik.values.Vehicle}
                          />
                          <span>Preferably</span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </CardBody>
          </Card>
          <Card
            id="jobCard "
            className="border-0 my-4"
            style={{ boxShadow: "0 4px 25px 0 rgba(0,0,0,.1)" }}
          >
            <p className="my-3 ml-4 headingStyle">Job Card Validity</p>
            <CardBody>
              <div className="">
                <Row>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Opening Date<span className="mandatory">*</span>
                      </Label>

                      <Flatpickr
                        value={formik.values.openingdate}
                        className={`form-control ${
                          formik.touched.openingdate &&
                          formik.errors.openingdate
                            ? "is-invalid"
                            : ""
                        } ${
                          formik.touched.openingdate &&
                          formik.errors.openingdate
                            ? "invalid-border"
                            : ""
                        }`}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate: new Date().fp_incr(0),
                          // minDate: new Date().fp_incr(0),
                        }}
                        styles={generateCustomStyles("openingdate", formik)}
                        name="openingdate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "openingdate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format("YYYY-MM-DD");
                            formik.setFieldValue("openingdate", formattedDate);
                          } else {
                            formik.setFieldValue("openingdate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.openingdate &&
                        formik.errors.openingdate && (
                          <FormFeedback>
                            {formik.errors.openingdate}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>
                  <Col sm="4">
                    <FormGroup>
                      <Label htmlFor="nameVertical">
                        Closing Date<span className="mandatory">*</span>
                      </Label>

                      <Flatpickr
                        className={`form-control ${
                          formik.touched.closingdate &&
                          formik.errors.closingdate
                            ? "is-invalid"
                            : ""
                        } ${
                          formik.touched.closingdate &&
                          formik.errors.closingdate
                            ? "invalid-border"
                            : ""
                        }`}
                        value={formik.values.closingdate}
                        placeholder="DD-MM-YYYY"
                        options={{
                          altInput: true,
                          altFormat: "F j, Y",
                          dateFormat: "Y-m-d",
                          // minDate:getCurrentDate()
                          // minDate: new Date().fp_incr(0),
                        }}
                        name="closingdate"
                        // onChange={(dates) => {
                        //   formik.setFieldValue(
                        //     "closingdate",
                        //     dates[0].toISOString().split("T")[0]
                        //   ); // Update formik value
                        // }}
                        onBlur={formik.handleBlur}
                        onChange={(dates) => {
                          if (dates?.[0]) {
                            const formattedDate = moment(dates[0]).format("YYYY-MM-DD");
                           
                            formik.setFieldValue("closingdate", formattedDate);
                          } else {
                            formik.setFieldValue("closingdate", ""); // Handle case when date is cleared
                          }
                        }}
                      />
                      {formik.touched.closingdate &&
                        formik.errors.closingdate && (
                          <FormFeedback>
                            {formik.errors.closingdate}
                          </FormFeedback>
                        )}
                    </FormGroup>
                  </Col>

                  <Col sm="4">
                    <div className="text-center">
                      <Label htmlFor="nameVertical">
                        Active Status
                        <span className="mandatory">*</span>
                      </Label>
                      <div
                        className={`d-flex justify-content-center ${
                          formik.touched.status && formik.errors.status
                            ? "radio-error"
                            : ""
                        }`}
                      >
                        <div className="mr-5">
                          <Input
                            type="radio"
                            name="status"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("status", "Active")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.status === "Active"}
                            value={formik.values.status}
                          />
                          <span>Active</span>
                        </div>
                        <div className="d-flex ">
                          {" "}
                          <Input
                            type="radio"
                            name="status"
                            style={{ accentColor: "#c16d18" }}
                            onChange={() =>
                              formik.setFieldValue("status", "Inactive")
                            }
                            onBlur={formik.handleBlur}
                            checked={formik.values.status === "Inactive"}
                            value={formik.values.status}
                          />
                          <span>InActive</span>
                        </div>
                      </div>
                      {formik.touched.status && formik.errors.status && (
                        <FormFeedback>{formik.errors.status}</FormFeedback>
                      )}
                    </div>
                  </Col>
                 
                </Row>
              </div>
            </CardBody>
          </Card>
          <div className=" text-right ">
            <button
              className="cancelBtn mr-2"
              onClick={() => history.push("/publish-job")}
            >
              Cancel
            </button>
            <button className="btns" onClick={submitHandler}>
              Submit
            </button>
          </div>
        </FormGroup>
      </div>
    </section>
  );
};

export default AddNewJob;
